<et-step-layout [data]="data">
  <div class="flex flex-column align-items-center">
    <span class="title3Font mt-8 mb-2"
          i18n>Templates</span>
    <span i18n>Firstly download the template to prepare manuscript</span>

    <div class="flex mt-3 justify-content-center">
      @for (template of templates; track template) {
        <div class="et-paper-template-entry flex flex-column align-items-center justify-content-center ml-3">
          <i (click)="onTemplateClick(template)"
             [class]="template.icon"></i>
          <span (click)="onTemplateClick(template)"
                class="font-bold mt-3">{{ template.name }}</span>
        </div>
      }
    </div>
  </div>
</et-step-layout>